import React from 'react';
import Breadcrumbs from 'apollo-react/components/Breadcrumbs';
import HouseIcon from 'apollo-react-icons/House';
import MedicalCard from 'apollo-react-icons/MedicalCard';
import Planner from 'apollo-react-icons/Planner';
import PresentationHierarchyLight from 'apollo-react-icons/PresentationHierarchyLight';
import StatusCheck from 'apollo-react-icons/StatusCheck';
import Bell from 'apollo-react-icons/Bell';
import FileAccountPlan from 'apollo-react-icons/FileAccountPlan';
import { adminRoutesConfig, customerRoutesConfig } from '../../routesConfig';

const personaConfigs = {
  admin: adminRoutesConfig,
  'end-user': customerRoutesConfig,
};

// Helper to find route config by path (supports params)
const findRouteByPath = (routes, path) => {
  return routes.find((route) => {
    // Replace :params with regex wildcards
    const routePattern = route.path.replace(/:[^/]+/g, '[^/]+');
    const regex = new RegExp(`^${routePattern}$`);
    return regex.test(path);
  });
};

// Improved getPageName
export const getPageName = (source, location) => {
  const routes = personaConfigs[source] || [];
  const pathname = location.pathname;

  if (source === 'end-user' && pathname.startsWith('/enduser/profile')) {
    if (pathname.startsWith('/enduser/profile/hcp')) return 'Profile';
    if (pathname.startsWith('/enduser/profile/account')) return 'My account';
    return 'Profile';
  }

  // Try to find a matching route
  const matchedRoute = routes.find((route) => {
    // Replace :params with regex wildcards
    const routePattern = route.path.replace(/:[^/]+/g, '[^/]+');
    const regex = new RegExp(`^${routePattern}$`);
    return regex.test(pathname);
  });

  return matchedRoute ? matchedRoute.title : 'home';
};

export const pageIcons = {
  home: <HouseIcon style={{ fontSize: '36px', color: '#4D4D4D' }} />,
  users: <MedicalCard style={{ fontSize: '36px', color: '#4D4D4D' }} />,
  'end-users': <MedicalCard style={{ fontSize: '36px', color: '#4D4D4D' }} />,
  roles: <MedicalCard style={{ fontSize: '36px', color: '#4D4D4D' }} />,
  categories: <MedicalCard style={{ fontSize: '36px', color: '#4D4D4D' }} />,
  forms: <Planner style={{ fontSize: '36px', color: '#4D4D4D' }} />,
  subforms: <Planner style={{ fontSize: '36px', color: '#4D4D4D' }} />,
  workflows: (
    <PresentationHierarchyLight
      style={{ fontSize: '36px', color: '#4D4D4D' }}
    />
  ),
  approvals: <StatusCheck style={{ fontSize: '36px', color: '#4D4D4D' }} />,
  reminders: <Bell style={{ fontSize: '36px', color: '#4D4D4D' }} />,
  logs: <FileAccountPlan style={{ fontSize: '36px', color: '#4D4D4D' }} />,
};

const CommonBreadcrumbs = ({ source, pathnames, location }) => {
  const routes = personaConfigs[source] || [];

  let rootHref = '';
  if (source === 'end-user') {
    rootHref = '/enduser/home';
  } else {
    rootHref = `/${source}/home`;
  }

  const items = [{ title: 'Home', href: rootHref }];

  let currentPath = '';
  pathnames.forEach((name, index) => {
    currentPath += `/${name}`;

    // check if this segment is a number (dynamic ID)
    const isNumeric = !isNaN(Number(name));

    // special handling for category detail pages (e.g., /categories/5)
    if (isNumeric && pathnames[index - 1] === 'categories') {
      // try to get category name from location state
      const categoryName = location?.state?.category?.name;
      if (categoryName) {
        items.push({
          title: categoryName,
          href: currentPath,
        });
      }
      return;
    }

    // If this segment is a number, skip adding it as a breadcrumb
    if (isNumeric) return;

    // Add if the path exists in persona config, or if the next segment is a number (to show parent like 'forms')
    const nextIsNumber =
      pathnames[index + 1] && !isNaN(Number(pathnames[index + 1]));
    const matched = findRouteByPath(routes, currentPath);
    if (matched || nextIsNumber) {
      // Prevent duplicates
      if (!items.some((item) => item.href === currentPath)) {
        const displayTitle = matched
          ? typeof matched.title === 'string'
            ? matched.title
            : String(matched.title)
          : name.replace(/-/g, ' ');
        items.push({ title: displayTitle, href: currentPath });
      }
    }
  });

  return (
    <Breadcrumbs
      items={items}
      className="capitalize"
      style={{
        padding: 0,
        color: '#999999',
        textDecoration: 'none',
        marginBottom: '27px',
      }}
    />
  );
};

export default CommonBreadcrumbs;
